export const BREEDPLAN_ACCURACY_URL =
  'https://breedplan.une.edu.au/general/understanding-ebv-accuracy/';
